import config from '../config'; // Assuming config has baseURL and token


export const initiatePayment = async (invoiceAmount, currencyIso) => {
    const response = await fetch(`${config.apiUrl}/api/initiate-payment`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ InvoiceAmount: invoiceAmount, CurrencyIso: currencyIso }),
    });
  
    if (!response.ok) throw new Error('Failed to initiate payment');
    return response.json();
  };
export const getPayment = async (paymentId, KeyType) => {
    const response = await fetch(`${config.apiUrl}/api/get-payment`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ Key: paymentId, KeyType: KeyType }),
    });
  
    if (!response.ok) throw new Error('Failed to initiate payment');
    return response.json();
  };

export const executePayment = async (paymentData) => {
    const response = await fetch(`${config.apiUrl}/api/execute-payment`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(paymentData),
    });
  
    // if (!response.ok) throw new Error('Failed to execute payment');
    return response.json();
  };

  export const createPayment = async (paymentData) => {
    const response = await fetch(`${config.apiUrl}/payments/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(paymentData),
    });
  
    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(JSON.stringify(errorResponse));
    }
    return response.json();
  };
  
export const updatePayment = async (paymentData) => {
  const response = await fetch(`${config.apiUrl}/payments/${paymentData.payment_id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(paymentData),
  });

  if (!response.ok) {
    const errorResponse = await response.json(); // Parse the error response
    throw new Error(JSON.stringify(errorResponse)); // Throw the real error message
  }
  return response.json();
};